import PropTypes from 'prop-types';

export const LoginFormValidations = PropTypes.shape({
  email: PropTypes.bool.isRequired,
  password: PropTypes.bool.isRequired,
});

export const LoginFormErrors = PropTypes.shape({
  errEmailNotFound: PropTypes.bool.isRequired,
  errPasswordIncorrect: PropTypes.bool.isRequired,
});

export const SignupFormValidations = PropTypes.shape({
  email: PropTypes.bool.isRequired,
  password: PropTypes.bool.isRequired,
  passwordConfirm: PropTypes.bool.isRequired,
  firstName: PropTypes.bool.isRequired,
  agreedToTermsAndConditions: PropTypes.bool.isRequired,
});

export const SignupFormErrors = PropTypes.shape({
  errEmailNonUnique: PropTypes.bool.isRequired,
});

export const AccountFormValidations = PropTypes.shape({
  email: PropTypes.bool.isRequired,
  firstName: PropTypes.bool.isRequired,
  descriptionMD: PropTypes.bool.isRequired,
});

export const AccountFormErrors = PropTypes.shape({
  errEmailNonUnique: PropTypes.bool.isRequired,
  errPasswordIncorrect: PropTypes.bool.isRequired,

  email: PropTypes.bool.isRequired,
  facebook: PropTypes.bool.isRequired,
  linkedin: PropTypes.bool.isRequired,
  website: PropTypes.bool.isRequired,
});

export const User = PropTypes.shape({
  id: PropTypes.number,
  email: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  state: PropTypes.string,
  zipcode: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
});
